class DeviceUtil {
    static mmConversionPx(value) {
        return parseInt(this.#mmConversionPx(value))
    }

    static pxConversionMm(value) {
        return parseInt(this.#pxConversionMm(value));
    }

    static dcConversionPx(value) {
        return parseInt(this.#mmConversionPx(value))
    }

    static pxConversionDc(value) {
        return Math.round(this.#pxConversionMm(value) * 100) / 100;
    }


    static round(num) {
        return Math.round(num * 100) / 100;
    }

    /**
    * 像素转毫米
    * 
    * @param {*} value 
    * @returns 
    */
    static #pxConversionMm(value) {
        return (value / this.#getHtmlDpi()[0]) * 25.4;
    }


    /**
     * 毫米转像素
     * 
     * @param {*} value 
     * @returns 
     */
    static #mmConversionPx(value) {
        return (value * this.#getHtmlDpi()[0]) / 25.4;
    }

    /**
    * 获取当前设备的DPI
    * 
    * @returns 
    */
    static #getHtmlDpi() {
        var arrDPI = new Array;
        if (window.screen.deviceXDPI) {
            arrDPI[0] = window.screen.deviceXDPI;
            arrDPI[1] = window.screen.deviceYDPI;
        } else {
            var tmpNode = document.createElement("DIV");
            tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
            document.body.appendChild(tmpNode);
            arrDPI[0] = tmpNode.offsetWidth;
            arrDPI[1] = tmpNode.offsetHeight;
            tmpNode.parentNode.removeChild(tmpNode);
        }
        return arrDPI;
    }
}


class GeometryUtil {
    static pointToEllipseDistance(xx, yy, x1, y1, x2, y2) {
        const x = x1 + (x2 - x1) / 2
        const y = y1 + (y2 - y1) / 2
        const a2 = Math.pow((x2 - x1) / 2, 2)
        const b2 = Math.pow((y2 - y1) / 2, 2)

        if (a2 > b2) {
            //计算焦点
            const c = Math.sqrt(a2 - b2)
            const d1 = Math.sqrt(Math.pow(xx - (x + c), 2) + Math.pow(yy - y, 2))
            const d2 = Math.sqrt(Math.pow(xx - (x - c), 2) + Math.pow(yy - y, 2))
            return Math.abs(d1 + d2 - Math.abs(x2 - x1))
        } else if (a2 < b2) {
            const c = Math.sqrt(b2 - a2)
            const d1 = Math.sqrt(Math.pow(yy - (y + c), 2) + Math.pow(xx - x, 2))
            const d2 = Math.sqrt(Math.pow(yy - (y - c), 2) + Math.pow(xx - x, 2))
            return Math.abs(d1 + d2 - Math.abs(y2 - y1))
        } else {
            const d1 = Math.sqrt(Math.pow(yy - y, 2) + Math.pow(xx - x, 2))
            return Math.abs(d1 + d1 - Math.abs(y2 - y1))
        }
    }

    static pointToRectDistance(xx, yy, x1, y1, x2, y2) {
        const len1 = this.pointToLineDistance(xx, yy, x1, y1, x2, y1)
        const len2 = this.pointToLineDistance(xx, yy, x2, y1, x2, y2)
        const len3 = this.pointToLineDistance(xx, yy, x1, y2, x2, y2)
        const len4 = this.pointToLineDistance(xx, yy, x1, y1, x1, y2)
        return Math.min(len1, len2, len3, len4)
    }

    static pointToLineDistance(xx, yy, x1, y1, x2, y2) {
        console.info(`${xx},${yy}||${x1},${y1}||${x2},${y2},`)
        if (x1 == x2) {
            if (yy > Math.max(y1, y2)) {
                return Math.sqrt(Math.pow(xx - x1, 2) + Math.pow(yy - Math.max(y1, y2), 2));
            } else if (yy < Math.min(y1, y2)) {
                return Math.sqrt(Math.pow(xx - x1, 2) + Math.pow(yy - Math.min(y1, y2), 2));
            } else {
                return Math.abs(xx - x1)
            }
        } else if (y1 == y2) {
            if (xx > Math.max(x1, x2)) {
                return Math.sqrt(Math.pow(yy - y1, 2) + Math.pow(xx - Math.max(x1, x2), 2));
            } else if (xx < Math.min(x1, x2)) {
                return Math.sqrt(Math.pow(yy - y1, 2) + Math.pow(xx - Math.min(x1, x2), 2));
            } else {
                return Math.abs(yy - y1)
            }
        } else {
            /** 求垂线交点
             * 直线方程  (y - y1) / (y2 - y1) = (x - x1) / (x2 - x1)  =>  y = (x - x1) / (x2 - x1) * (y2 - y1) + y1
             * 斜率      k1 = (y2 - y1) / (x2 - x1)
             * 垂线斜率  k2 = -1 / k1
             * 垂线平移  b = yy - k2 * xx
             * 垂线方程  y = k2 * x + b
             * 求两直线交点 (x - x1) / (x2 - x1) * (y2 - y1) + y1 = k2 * x + b
             * => ((y2 - y1) / (x2 - x1) - k2) * x = b - y1 + ((y2 - y1) / (x2 - x1)) * x1
             * => (k1 - k2) * x = b - y1 + k1 * x1
             */
            const k1 = (y2 - y1) / (x2 - x1)
            const k2 = -1 / k1
            const b = yy - k2 * xx
            // 两直线交点
            const x = (b - y1 + k1 * x1) / (k1 - k2)
            const y = k2 * x + b
            const [[minX, minY], [maxX, maxY]] = x1 < x2 ? [[x1, y1], [x2, y2]] : [[x2, y2], [x1, y1]]
            // 如果中垂线的交点在线段外，那么距离就是点到直线端点的距离
            if (x > maxX) {
                return Math.sqrt((xx - maxX) ** 2 + (yy - maxY) ** 2)
            }
            if (x < minX) {
                return Math.sqrt((xx - minX) ** 2 + (yy - minY) ** 2)
            }
            return Math.sqrt((xx - x) ** 2 + (yy - y) ** 2)
        }
    }

    /**
     * 判断点是否在矩形框内
     * 
     * @param {*} point  点
     * @param {*} rect  矩形框{x,y,w,h}
     * @returns 
     */
    static pointInRect(xx, yy, x1, y1, x2, y2) {
        let xin = false
        let yin = false
        if (x1 - x2 >= 0) {
            xin = (x1 >= xx && xx >= x2)
        } else {
            xin = (x2 >= xx && xx >= x1)
        }
        if (y1 - y2 >= 0) {
            yin = (y1 >= yy && yy >= y2)
        } else {
            yin = (y2 >= yy && yy >= y1)
        }
        return xin && yin
    }
}

export {
    DeviceUtil, GeometryUtil
}
